// extracted by mini-css-extract-plugin
export var addressCarousel = "carousel-module--address-carousel--75847";
export var addressCarouselItem = "carousel-module--address-carousel-item--c7a28";
export var addressImg = "carousel-module--address-img--c84be";
export var addressImgSolo = "carousel-module--address-img-solo--0123c";
export var carouselLightBoxOpener = "carousel-module--carousel-light-box-opener--6f0c2";